import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../../http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class PinPadService {

  constructor(private http: HttpClient, private httpService: HttpService) { }



  pinpadAlive() {
    let params = {};
    return this.http.get("http://localhost:8080/sdkadiq/testAlive", {params, observe: "response"});
  }

  findPorts() {
    let params = {};
    return this.http.get("http://localhost:8080/sdkadiq/findPorts", {params});
  }

  openPort(data: any) {
    let params = data;
    return this.http.post("http://localhost:8080/sdkadiq/openSafePort", null, {params});
  }

  getSerial() {
    let params = {};
    return this.http.get("http://localhost:8080/sdkadiq/getSerial", {params});
  }

  closePort() {
    let params = {};
    return this.http.get("http://localhost:8080/sdkadiq/closePort", {params});
  }

}
